import React from "react";
import { connect } from "react-redux";

import Result from "antd/es/result";
import { useIntl } from "react-intl";

import ImportStatus from "@mapmycustomers/shared/enum/imports/ImportStatus";
import Import from "@mapmycustomers/shared/types/imports/Import";

import { updateStartedImport } from "@app/scene/settings/component/Imports/store/actions";
import { getStartedImport } from "@app/scene/settings/component/Imports/store/selectors";
import { downloadFile } from "@app/store/files/actions";
import { RootState } from "@app/store/rootReducer";
import useInterval from "@app/util/hook/useInterval";

import useResultState, { ImportResultState } from "./useResultState";

interface Props {
  downloadFile: typeof downloadFile;
  startedImport?: Import;
  updateStartedImport: typeof updateStartedImport.request;
}

const FinalizeStep: React.FC<Props> = ({ downloadFile, startedImport, updateStartedImport }) => {
  const intl = useIntl();

  useInterval(
    updateStartedImport,
    !!startedImport &&
      ![ImportStatus.COMPLETED, ImportStatus.ERRORED].includes(startedImport.status),
    3000
  );

  const { extra, img, subTitle, title }: ImportResultState = useResultState(
    intl,
    downloadFile,
    startedImport
  );

  return (
    <div>
      <Result extra={extra} icon={img} subTitle={subTitle} title={title} />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  startedImport: getStartedImport(state),
});

const mapDispatchToProps = {
  downloadFile,
  updateStartedImport: updateStartedImport.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(FinalizeStep);
